module.exports = __webpack_public_path__ + "img/file-document.2ee56940.svg";